import { Alert, AlertIcon, AlertTitle } from "@chakra-ui/react";
import React from "react";

interface Props {
    text: string;
}

export const AlertCard = ({ text }: Props) => {
    return <Alert
        status='warning'
        variant='left-accent'
        flexDirection='row'
        gap='1rem'
        alignItems='center'
        justifyContent='start'
        height='5rem'
        borderEndRadius='md'
    >
        <AlertIcon boxSize='40px' />
        <AlertTitle fontSize='lg'>
            {text}
        </AlertTitle>
    </Alert>
}